export type CadColorName =
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "9"
  | "10"
  | "11"
  | "12"
  | "13"
  | "14"
  | "15"
  | "16"
  | "17"
  | "18"
  | "19"
  | "20";

export type CadColor = {
  name: CadColorName;
  label: string;
  value: string;
};

export const CAD_COLOR_SET: CadColor[] = [
  { name: "1", label: "1 - Red", value: "#ff0000" },
  { name: "2", label: "2 - Yellow", value: "#ffff00" },
  { name: "3", label: "3 - Green", value: "#00ff00" },
  { name: "4", label: "4 - Cyan", value: "#00ffff" },
  { name: "5", label: "5 - Blue", value: "#0d00fc" },
  { name: "6", label: "6 - Magenta", value: "#ff00ff" },
  { name: "7", label: "7 - White", value: "#ffffff" },
  { name: "8", label: "8 - Orange", value: "#ff7f00" },
  { name: "9", label: "9 - Brown", value: "#8b4513" },
  { name: "10", label: "10 - Purple", value: "#8000ff" },
  { name: "11", label: "11 - Lime", value: "#80ff00" },
  { name: "12", label: "12 - Sky", value: "#0080ff" },
  { name: "13", label: "13 - Rose", value: "#ff0080" },
  { name: "14", label: "14 - Teal", value: "#008080" },
  { name: "15", label: "15 - Black", value: "#000000" },
  { name: "16", label: "16 - Gray 20", value: "#333333" },
  { name: "17", label: "17 - Gray 40", value: "#666666" },
  { name: "18", label: "18 - Gray 55", value: "#8c8c8c" },
  { name: "19", label: "19 - Gray 70", value: "#b3b3b3" },
  { name: "20", label: "20 - Gray 85", value: "#d9d9d9" },
];

export const getCadColorValue = (name: CadColorName) =>
  CAD_COLOR_SET.find((color) => color.name === name)?.value ?? CAD_COLOR_SET?.[0]?.value ?? "#ff0000";

export const AUTOCAD_STANDARD_COLORS = CAD_COLOR_SET.map((color) => ({
  aci: Number(color.name),
  label: color.label,
  value: color.value,
}));
